import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Home from '../../Common/Home/Home';
import PPOConfiguration from './PPOConfiguration';
import authContext from '../../../../AuthContext/authContext';

const base_url = process.env.REACT_APP_BASE_URL;

const PPOConfigurationWrapper = () => {
  const { companyId } = useParams();
  const ctx = useContext(authContext);
  const token = ctx.token;
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    ppoNote: '',
    ppoPassCount: 0,
    expiryDate: '',
    isActive: true
  });
  const fetchCompanyData = async () => {
    try {
      const response = await axios.get(`${base_url}/company/details/${companyId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      setCompanyData(response.data);
      
      // Get the latest PPO entry or use defaults
      const ppoData = response.data.ppoData || [];
      const sortedPpoData = [...ppoData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const latestPpo = sortedPpoData.length > 0 ? sortedPpoData[0] : null;
      
      // Set default values for new PPO
      if (latestPpo) {
        setInitialValues({
          ppoNote: latestPpo.ppoNote || '',
          ppoPassCount: latestPpo.availablePassCount || 0,
          expiryDate: latestPpo.expiryDate ? new Date(latestPpo.expiryDate) : new Date(),
          isActive: latestPpo.isActive !== undefined ? latestPpo.isActive : true
        });
      } else {
        // Default values for new PPO
        setInitialValues({
          ppoNote: '',
          ppoPassCount: 0,
          expiryDate: new Date(),
          isActive: true
        });
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching company data:', error);
      toast.error('Failed to load company data');
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchCompanyData();
  }, [companyId, token]);


  const handleSubmit = async (values) => {
    try {
      const ppoData = {
        companyId: companyId,
        ppoNote: values.ppoNote,
        addTopUpPasses: values.addTopUpPasses,
        isSubscriptionExpired: values.isSubscriptionExpired,
        ppoPassCount: parseInt(values.ppoPassCount),
        ppoExpiryDate: values.expiryDate ? new Date(values.expiryDate).toISOString() : null
      };

      await axios.post(`${base_url}/company/create-ppo-subscription/${companyId}`, ppoData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
      });

      toast.success('PPU configuration updated successfully');
      fetchCompanyData();
      return true;
    } catch (error) {
      console.error('Error updating PPO configuration:', error);
      toast.error('Failed to update PPO configuration');
      return false;
    }
  };

  return (
    <Home
      propComponent={
        <PPOConfiguration
          companyId={companyId}
          companyData={companyData}
          initialValues={initialValues}
          loading={loading}
          onSubmit={handleSubmit}
        />
      }
    />
  );
};

export default PPOConfigurationWrapper;
